import { render, staticRenderFns } from "./InboxPagesHeader.vue?vue&type=template&id=3b3a45b5&"
import script from "./InboxPagesHeader.vue?vue&type=script&lang=js&"
export * from "./InboxPagesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports